import { useEffect } from 'react';
import axios from 'axios';
import useModalStore from '../../../zustand/store/useModalStore';

import '../../../css/modal.css';

const ExcelDownloadReason_layer = ({ isModalOpen, closeModal, updateParams, handleUpdateInputChange, searchParams, route, excelFileName, setIsDown }) => {

    const useridno = localStorage.getItem('id');
    const downReason = updateParams.downreason;

    const showNotiModal = useModalStore(state => state.showNotiModal);

    const updateNedisSendErro = async (updateParams) => {
        try {
            if (window.confirm("현재 내용을 저장하시겠습니까?")) {
                await axios.post('/commonapi/exceldown/insert_xlsx_down_reason.do', {
                    useridno: useridno,
                    downreason: updateParams.downreason,
                    downetc: updateParams.bigo,
                    downURL: route,
                    downParams: new URLSearchParams(searchParams).toString(),
                    downFileName: excelFileName
                });
                closeModal();
                showNotiModal('저장되었습니다.');
                setIsDown(true);
            }
        } catch (error) {
            console.error('입력사유 저장 중 오류 발생:', error);
        }
    };

    const save = (updateParams) => {
        if (updateParams.downreason === '4' && updateParams.bigo.length < 10) {
            alert('기타사유 상세내용은 10자 이상 입력해주시기 바랍니다.');
            return false;
        }

        if (updateParams.downreason === "") {
            alert('다운로드 사유를 선택해주시기 바랍니다.');
            return false;
        }
        updateNedisSendErro(updateParams);
    };

    // esc 키 누르면 모달 닫히는 기능
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === "Escape") closeModal();
        };

        // 이벤트 리스너 등록
        document.addEventListener("keydown", handleEscape);

        // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
        return () => {
            document.removeEventListener("keydown", handleEscape);
        };
    }, [closeModal]);

    return (
        <>
            {isModalOpen &&
                <div className={route === '/nedis/jinryoweb/bdjrnaeyeokdetaillistA.do' ? 'layer_container_detail' : ' layer_container'}>
                    <div className='layer_wrapper'>
                        <div className='modal_title_box'>
                            <h4>개인정보를 포함한 엑셀 다운로드 사유 입력</h4>
                        </div>
                        <div className='text-center'>
                            <p className='bold co_red'>개인정보를 포함한 엑셀 다운로드 시, 사유 입력이 필요합니다.</p>
                            <p className='bold co_red'>다운로드 사유가 입력되지 않은 경우 엑셀 데이터를 다운로드 할 수 없습니다.</p>
                            <p className='bold co_red'>기타 사유로 입력하는 경우, 다운로드 사유를 상세하게 입력해주시기 바랍니다.</p>
                        </div>
                        <hr />
                        <div className='layer_section_b'>
                            <h5>다운로드 사유</h5>
                            <hr />
                            <div className='radio_wrapper'>
                                <select id="downreason" name="downreason" value={updateParams.downreason} onChange={handleUpdateInputChange}>
                                    <option value="">선택</option>
                                    <option value="1">기관 제출용</option>
                                    <option value="2">내부 보관용</option>
                                    <option value="3">통계 분석 및 관리용</option>
                                    <option value="4">기타</option>
                                </select>
                            </div>
                            <hr />
                        </div>
                        <div className='layer_section_b'>
                            <h5>기타사유</h5>
                            <hr />
                            <textarea name="bigo"
                                className='textarea_style h-24'
                                placeholder='기타사유 상세내용'
                                value={updateParams.bigo}
                                onChange={handleUpdateInputChange}
                                maxLength={1000}
                                disabled={downReason !== "4"} />
                        </div>
                        <hr />
                        <div className='modal_btn_box'>
                            <div className={`modal_btn bg_st_primary cursor-pointer`} onClick={() => save(updateParams)}>저장</div>
                            <div className='modal_btn bg_co_black cursor-pointer' onClick={closeModal}>닫기</div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default ExcelDownloadReason_layer